<template>
  <div v-if="!loading">
    <div class="actions">
      <slot name="actions" />
      <button v-if="requiresApproval || approving" type="button" @click="approve" class="bg-tertiary text-white py-2 px-6 rounded" :disabled="approving">
        <i v-if="approving" class="fas fa-circle-notch fa-fw fa-lg fa-spin" />
        <span v-else>Approve</span>
      </button>
    </div>
    <form @submit="save" class="recruitment-section">
      <div class="mb-4">
        <label class="label-xs">
          Job Title
        </label>
        <input
          v-model="listing.job_title"
          type="text"
          class="input-sm w-full"
          required>
        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('job_title')" v-text="errorBag.get('job_title')"></small>
      </div>
      <div class="mb-4">
        <label class="label-xs">
          Department
        </label>
        <input
          v-model="listing.job_department"
          type="text"
          class="input-sm w-full"
          required>
        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('job_department')" v-text="errorBag.get('job_department')"></small>
      </div>
      <div class="mb-4">
        <label class="label-xs">
          Job Type
        </label>
        <select name="job_type" v-model="listing.job_type" class="w-full border input-sm p-2">
          <option :value="null">Please select</option>
          <option v-for="(name, i) in jobTypeOptions" :key="i" :value="i">
            {{ name }}
          </option>
        </select>
        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('job_type')" v-text="errorBag.get('job_type')"></small>
      </div>
      <div class="mb-4">
        <label class="label-xs">
          Salary
        </label>
        <input
          v-model="listing.salary"
          type="text"
          class="input-sm w-full"
          required>
        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('salary')" v-text="errorBag.get('salary')"></small>
      </div>
      <div class="mb-4">
        <label class="label-xs">
          Summary
        </label>
        <textarea
          maxlength="512"
          v-model="listing.summary"
          type="text"
          class="input-sm w-full"
          rows="3"
          required>
        </textarea>
        <div class="text-right mt-2 text-sm" :class="(listing.summary ? listing.summary.length : 0) === 512 ? 'text-red': 'text-grey'">
         {{ listing.summary ?  listing.summary.length : 0}} / 512
        </div>
        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('summary')" v-text="errorBag.get('summary')"></small>
      </div>
      <div class="mb-4">
        <label class="label-xs">
          Description
        </label>
        <editor
          @update="listing.description = $event"
          :content="listing.description ? listing.description : ''"
          class="application-description input-sm mt-0"
        />
      </div>
      <div class="mb-4">
        <label class="label-xs">
          Contact Name
        </label>
        <input
          v-model="listing.contact_name"
          type="text"
          class="input-sm w-full"
          required>
        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('contact_name')" v-text="errorBag.get('contact_name')"></small>
      </div>
      <div class="mb-4">
        <label class="label-xs">
          Contact Number
        </label>
        <input
          v-model="listing.contact_number"
          type="text"
          class="input-sm w-full"
          required>
        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('contact_number')" v-text="errorBag.get('contact_number')"></small>
      </div>
      <div class="mb-4">
        <label class="label-xs">
          Contact Email
        </label>
        <input
          v-model="listing.contact_email"
          type="text"
          class="input-sm w-full"
          required>
        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('contact_email')" v-text="errorBag.get('contact_email')"></small>
      </div>
      <div class="mb-4">
        <label class="label-xs">
          Location
        </label>
        <input
          v-model="listing.display_address"
          type="text"
          class="input-sm w-full">
        <small>
          Will override the default office location
        </small>
        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('display_address')" v-text="errorBag.get('display_address')"></small>
      </div>
      <div class="mb-4">
        <div
          class="relative flex items-end justify-center w-48 h-48 bg-grey-lighter border bg-center bg-cover bg-no-repeat"
          :style="{ backgroundImage: `url(${listing.image_url})` }"
        >
          <!-- <img v-if="previewUrl" :src="previewUrl" alt="image" class="absolute"> -->
          <button
            type="button"
            class="absolute z-20 cursor-pointer pin-t pin-r h-6 w-6 flex items-center justify-center -m-2 bg-white text-black rounded-full border shadow"
            @click.stop="removeImage"
          >
            <i class="fas fa-times fa-fw fa-xs" />
          </button>
          <span class="relative mb-4 w-3/5 text-center text-sm text-grey-light font-bold">
            <i class="fas fa-camera"></i>
            <br>
            Drop an image to change
          </span>
          <input type="file" name="image" id="image" accept="image/*" class="absolute w-full h-full opacity-0 cursor-pointer" @change="imageChanged">
        </div>
        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('image')" v-text="'Valid Logo is required for proceeding'"></small>
      </div>
      <div>
        <button type="submit" class="bg-tertiary text-white py-2 px-6 rounded" :disabled="saving">
          <i v-if="saving" class="fas fa-circle-notch fa-fw fa-lg fa-spin" />
          <span v-else>Save</span>
        </button>
      </div>
    </form>
  </div>

  <loader v-else class="my-10" />
</template>

<script>
import { v2Api } from '@/http'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import ErrorBag from '@/ErrorBag'

export default {
  props: ['listing'],

  data () {
    return {
      loading: false,
      saving: false,
      approving: false,
      imageFile: null,
      jobTypeOptions: [],
      errorBag: new ErrorBag()
    }
  },

  computed: {
    ...mapState([ 'profile', 'selectedOffice' ]),

    requiresApproval () {
      return [0, 1].includes(this.profile.type) && this.listing.id && !this.listing.approved
    }
  },
  created () {
    this.getJobTypeOptions()
  },
  methods: {
    ...mapActions(['displayToastNotification']),

    moment: moment,
    load () {
      this.loading = true

      v2Api
        .get(`/recruitment-listings/${this.listing.id}`)
        .then(response => {
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    imageChanged (e) {
      let file = e.target.files[0]
      this.listing.image_url = URL.createObjectURL(file)
      this.listing.image = file
    },

    removeImage () {
      this.listing.image = null
      this.listing.image_url = null
    },

    async save (e) {
      e.preventDefault()

      this.saving = true

      let formData = new FormData()
      let route = '/recruitment-listings'
      if (this.listing.id) {
        route += `/${this.listing.id}`
        formData.append('_method', 'PATCH')
      } else {
        this.listing.office_id = this.selectedOffice.id
      }

      for (var key in this.listing) {
        let value = this.listing[key]
        if (!value) {
          continue
        }
        if (Array.isArray(value) || typeof value === 'boolean') {
          continue
        }
        formData.append(key, value)
      }

      this.errorBag.clear()
      v2Api.post(route, formData)
        .then(response => {
          // this.listing = response.data
          this.imageUrl = response.data.image_url
          this.saving = false
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Approved',
            info: `${this.listing.job_title} has been successfully saved.`
          })
          this.$emit('saved')
        }, (errors) => {
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times',
            title: 'Unable to save application',
            info: errors.response.data.message
          })
          this.errorBag.store(errors.response.data)
          this.saving = false
        })
    },

    approve () {
      this.approving = true
      this.listing.approved = true

      v2Api
        .post(`/recruitment-listings/${this.listing.id}/approve`)
        .then(response => {
          this.listing.approved = true
          this.listing.published = true
          this.approving = false
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Approved',
            info: `${this.listing.job_title} has been successfully approved.`
          })
        })
        .catch(() => {
          this.approving = false
          this.listing.approved = false
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times',
            title: 'Unable to approve',
            info: `We've been unable to approve ${this.listing.job_title} at this time.`
          })
        })
    },
    getJobTypeOptions () {
      v2Api
        .get(`/recruitment-listings/enums`)
        .then(
          response => {
            this.jobTypeOptions = response.data.job_type
          }
        )
    }
  }
}
</script>

<style lang="sass" scoped>
</style>

<style lang="sass">
.application-description .ProseMirror
  @apply min-h-32
</style>
